<template>
  <div class="">
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0" class="demo-ruleForm" size="small">
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item prop="addr">
            <el-input 
              :rows="5" 
              type="textarea" 
              v-model="ruleForm.addr"
              :placeholder="$t('order.fplace.resolution.dizhi')"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item style="text-align: right;">
        <el-button 
          size="small" 
          type="primary" 
          @click="submitForm('ruleForm')"
        >
          {{ $t('order.fplace.resolution.tijiao') }}
        </el-button>
        <el-button 
          size="small" 
          @click="resetForm('ruleForm')"
        >
          {{ $t('order.fplace.resolution.guanbi') }}
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    resoluNum: {
      type: Number,
      default: 0
    }
  },
  data() {
    // 美国州映射表：简写 => 全称（核心新增）
    const US_STATE_MAP = {
      "DC": "District of Columbia",
      "AS": "American Samoa",
      "GU": "Guam",
      "MP": "Northern Mariana Islands",
      "PR": "Puerto Rico",
      "UM": "United States Minor Outlying Islands",
      "VI": "Virgin Islands, U.S.",
      "AL": "Alabama",
      "AK": "Alaska",
      "AZ": "Arizona",
      "AR": "Arkansas",
      "CA": "California",
      "CO": "Colorado",
      "CT": "Connecticut",
      "DE": "Delaware",
      "FL": "Florida",
      "GA": "Georgia",
      "HI": "Hawaii",
      "ID": "Idaho",
      "IL": "Illinois",
      "IN": "Indiana",
      "IA": "Iowa",
      "KS": "Kansas",
      "KY": "Kentucky",
      "LA": "Louisiana",
      "ME": "Maine",
      "MD": "Maryland",
      "MA": "Massachusetts",
      "MI": "Michigan",
      "MN": "Minnesota",
      "MS": "Mississippi",
      "MO": "Missouri",
      "MT": "Montana",
      "NE": "Nebraska",
      "NV": "Nevada",
      "NH": "New Hampshire",
      "NJ": "New Jersey",
      "NM": "New Mexico",
      "NY": "New York",
      "NC": "North Carolina",
      "ND": "North Dakota",
      "OH": "Ohio",
      "OK": "Oklahoma",
      "OR": "Oregon",
      "PA": "Pennsylvania",
      "RI": "Rhode Island",
      "SC": "South Carolina",
      "SD": "South Dakota",
      "TN": "Tennessee",
      "TX": "Texas",
      "UT": "Utah",
      "VT": "Vermont",
      "VA": "Virginia",
      "WA": "Washington",
      "WV": "West Virginia",
      "WI": "Wisconsin",
      "WY": "Wyoming"
    };

    // 反向映射：全称 => 全称（统一查询逻辑）
    const US_STATE_FULL_NAMES = Object.values(US_STATE_MAP);

    // 定义地址验证方法（内部方法，供rules调用）
    const validateAddr = (rule, value, callback) => {
      // 1. 非空验证（优先触发）
      if (!value || value.trim() === '') {
        return callback(new Error(this.$t('order.fplace.resolution.dizhibk')));
      }

      // 2. 格式解析验证
      const lines = value.trim().split(/\n+/).filter(line => line.trim());
      if (lines.length !== 3) {
        return callback(new Error(this.$t('order.fplace.resolution.dizhigeshi')));
      }

      const [name, phone, addressLine] = lines;
      if (!name.trim()) return callback(new Error(this.$t('order.fplace.resolution.xingming')));
      if (!phone.trim()) return callback(new Error(this.$t('order.fplace.resolution.dianhua')));

      // 核心修改1：兼容地址行中 逗号+空格 或 空格 分隔的邮编（先处理邮编拆分）
      let addressMain = '';
      let zipCode = '';
      // 匹配最后一个空格后的数字（邮编）
      const zipMatch = addressLine.match(/(.*)\s+(\d{5}(-\d{4})?)$/);
      if (zipMatch) {
        addressMain = zipMatch[1].trim(); // 邮编前的地址部分
        zipCode = zipMatch[2]; // 邮编
      } else {
        return callback(new Error(this.$t('order.fplace.resolution.dizhihang')));
      }

      // 拆分地址主部分（detailAddr, city, state）
      const addressParts = addressMain.split(",").map(part => part.trim());
      if (addressParts.length !== 3) {
        return callback(new Error(this.$t('order.fplace.resolution.dizhikhang')));
      }

      const [detailAddr, city, stateInput] = addressParts;
      if (!detailAddr || !city || !stateInput || !zipCode) {
        return callback(new Error(this.$t('order.fplace.resolution.dizhikhang')));
      }

      // 核心修改2：验证并统一州名称（支持全称/简写）
      const stateNormalized = stateInput.trim().toUpperCase();
      let fullStateName = '';
      // 先判断是否是简写
      if (US_STATE_MAP[stateNormalized]) {
        fullStateName = US_STATE_MAP[stateNormalized];
      } else {
        // 再判断是否是全称（忽略大小写）
        const matchedState = US_STATE_FULL_NAMES.find(
          fullName => fullName.toLowerCase() === stateInput.toLowerCase()
        );
        if (matchedState) {
          fullStateName = matchedState;
        }
      }

      // 州验证失败
      if (!fullStateName) {
        return callback(new Error(this.$t('order.fplace.resolution.meiguozhou')));
      }

      // 所有验证通过
      callback();
    };

    return {
      ruleForm: {
        addr: '', // 核心地址字段（必须和prop对应）
        company: '',
        address_two: '',
        email: '',
        user_type: '' // 补充user_type字段，避免rules报错
      },
      // 规范的rules配置（验证逻辑完全内聚在这里）
      rules: {
        addr: [
          { validator: validateAddr, trigger: ['blur', 'change', 'submit'] }, // 多时机触发
        ],
      },
      // 暴露州映射表供methods使用
      US_STATE_MAP
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          try {
            // 解析地址数据（提交时二次解析，确保数据正确）
            const lines = this.ruleForm.addr.trim().split(/\n+/).filter(line => line.trim());
            const [name, phone, addressLine] = lines;
            
            // 解析邮编（兼容空格分隔）
            const zipMatch = addressLine.match(/(.*)\s+(\d{5}(-\d{4})?)$/);
            const addressMain = zipMatch[1].trim();
            const zipCode = zipMatch[2];
            
            // 拆分地址主部分
            const [detailAddr, city, stateInput] = addressMain.split(",").map(part => part.trim());
            
            // 统一州名称为全称（核心逻辑）
            const stateNormalized = stateInput.trim().toUpperCase();
            let stateFullName = '';
            if (this.US_STATE_MAP[stateNormalized]) {
              stateFullName = this.US_STATE_MAP[stateNormalized];
            } else {
              // 匹配全称（忽略大小写）
              const fullNames = Object.values(this.US_STATE_MAP);
              stateFullName = fullNames.find(
                full => full.toLowerCase() === stateInput.toLowerCase()
              ) || '';
            }
            
            // 构造提交数据（确保返回全称）
            let obj = {
              address_one: detailAddr,
              city: city,
              country: "United States",
              mobile: phone,
              province: stateFullName, // 统一返回全称
              realname: name,
              user_type: this.resoluNum,
              zcode: zipCode,
            };
            this.$emit('resoluResult', this.resoluNum, obj);
          } catch (error) {
            console.error('地址解析失败：', error);
          }
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.ruleForm = {
        addr: '',
        company: '',
        address_two: '',
        email: '',
        user_type: ''
      };
      this.$emit('resoluResult', 0, {});
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-form-item__content{
  text-align: right !important;
}
::v-deep .el-textarea__inner {
  resize: vertical;
}
// 修复验证错误提示位置
::v-deep .el-form-item__error {
  text-align: left !important;
}
</style>    